import { useParams, useNavigate } from 'react-router-dom';
import Spinner from 'src/components/_common/Spinner/Spinner';
import { useIntl } from 'react-intl';
import { useEffect } from 'react';
import ClassFormsTable from 'src/components/ClassFormsTable/ClassFormsTable';
import PageHeader from 'src/components/_common/PageHeader/PageHeader';
import Badge from 'src/components/_common/Badge/Badge';
import List from 'src/components/_common/List/List';
import ListItem from 'src/components/_common/List/ListItem';
import SigningFormStatus from 'src/components/SigningFormStatus/SigningFormStatus';
import { SimpleUser } from 'src/models/classes';
import ClassesContext from '../../../../hooks/useClasses';

const SupervisorClass = () => {
  const { getCurrentClass, currentClass, currentClassLoaded, getMyStudents, myStudents, myStudentsLoaded } = ClassesContext.useContainer();
  const { classId } = useParams<{classId: string}>();
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (classId) {
      getCurrentClass(+classId);
      getMyStudents(+classId);
    }
  }, [classId]);

  const navigateToStudent = (student: SimpleUser) => navigate(`/advisor/class/${classId}/student/${student.id}`);

  if (!(currentClassLoaded || myStudentsLoaded)) return <Spinner />;

  return (
    <>
      <PageHeader title={currentClass?.subject?.subjectCode} subTitle={currentClass?.subject?.name}>
        <Badge>{currentClass?.period?.name}</Badge>
      </PageHeader>
      <ClassFormsTable baseRoute="/advisor" currentClass={currentClass} subjectCode={currentClass?.subject?.subjectCode} />
      <List
        className="pt-8"
        title={formatMessage({ id: 'my-students' })}
        emptyListMessage={formatMessage({ id: 'table-none-added' }, { name: formatMessage({ id: 'students' }).toLowerCase() })}
        listIsEmpty={!myStudents || myStudents.length === 0}
      >
        {myStudents?.map(student => (
          <ListItem key={student.id} onClick={() => navigateToStudent(student)}>
            <span className="inline-flex items-center flex-wrap">
              {student.displayName}
              <SigningFormStatus signingForm={student.signingForm ?? null} />
            </span>
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default SupervisorClass;
